<ng-container *ngIf="noEmpty">
    <h2 class="section-title margin-upside-down">Suggested next step</h2>
    <section class="swiper-container">
        <section class="most-zp" id="mostZp">
            <div class="presentation">Here's how you can make the most of <span *ngIf="!isDefaultTheme">{{text}}</span><span *ngIf="isDefaultTheme==true">{{text}}</span>.</div>
            <div class="icon"><i class="fa fas fa-arrow-right"></i></div>
        </section>
        <section class="swiper-wrapper">
            <!-- <div class="pass"></div> -->
            <ng-container *ngFor="let nextStep of resultsNextSteps; let i = index; let last = last">
                <section class="swiper-slide" [ngClass]="{dropdownClass: nextStep.dropdown}">
                    <header class="title-card">
                        <img src="../../assets/img/{{themeService.theme}}/{{nextStep.image}}" alt="" width="60px">
                        <div class="title">{{nextStep.title}}</div>
                    </header>
                    <section class="main-card">
                        <div class="header">
                            <img src="../../assets/img/{{nextStep.image}}" alt="" width="60px">
                        </div>
                        <div class="main">
                            <div class="title">{{nextStep.title}}</div>
                            <div class="explanations">{{nextStep.copy}}</div>
                            <ng-container *ngIf="nextStep.dropdown">
                                <select name="" id="">
                                    <option *ngFor="let item of nextStep.dropdown">{{item}}</option>
                                </select>
                            </ng-container>
                            <div class="btn-part">
                                <input type="button" *ngIf="nextStep.buttonFunc" class="btn btn-primary primary-sml-btn"
                                    value="{{nextStep.buttonCopy}}" (click)="handleButtonFunc(nextStep.buttonFunc)">
                                <input type="button" *ngIf="!nextStep.buttonFunc"
                                    class="btn btn-primary primary-sml-btn" value="{{nextStep.buttonCopy}}"
                                    [routerLink]="[nextStep.buttonLink]">
                                <span class="skip" (click)="skip(nextStep._id,i)">Skip X</span>
                            </div>
                        </div>
                    </section>
                    <div class="pass" [ngClass]="{'last-child': last}"></div>
                </section>
            </ng-container>
        </section>

        <!-- Add Arrows -->
        <div class="next-step step-btn" id="nextStep">
            <span>Next</span>
            <div class="svg-container svg-next-step">
                <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0)">
                        <path class="svg-background"
                            d="M9.17741 32.2142C2.82292 26.8821 2.17387 20.3624 10.2936 12.5286C18.4133 4.69484 26.3102 4.81724 33.0296 10.4555C39.749 16.0938 35.8395 23.8061 30.4471 30.2326C25.0547 36.659 15.5319 37.5462 9.17741 32.2142Z" />
                        <g clip-path="url(#clip1)">
                            <path class="svg-sign"
                                d="M19.8897 16.1085L14.1961 22.1818C13.9215 22.4747 13.9215 22.9495 14.1961 23.2424L14.8602 23.9508C15.1343 24.2432 15.5786 24.2437 15.8534 23.952L20.3869 19.1388L24.9205 23.952C25.1953 24.2437 25.6395 24.2432 25.9137 23.9508L26.5777 23.2424C26.8523 22.9495 26.8523 22.4746 26.5777 22.1818L20.8841 16.1085C20.6095 15.8156 20.1643 15.8156 19.8897 16.1085Z" />
                        </g>
                    </g>
                    <defs>
                        <clipPath id="clip0">
                            <path d="M0 0H41.2524V41.8687H0V0Z" fill="white" />
                        </clipPath>
                        <clipPath id="clip1">
                            <rect width="10" height="15"
                                transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 27.6265 24.4343)" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
        </div>
        <div class="prev-step step-btn" id="prevStep">
            <div class="svg-suggested-next-step-container svg-prev-step">
                <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0)">
                        <path class="svg-background"
                            d="M9.17741 32.2142C2.82292 26.8821 2.17387 20.3624 10.2936 12.5286C18.4133 4.69484 26.3102 4.81724 33.0296 10.4555C39.749 16.0938 35.8395 23.8061 30.4471 30.2326C25.0547 36.659 15.5319 37.5462 9.17741 32.2142Z" />
                        <g clip-path="url(#clip1)">
                            <path class="svg-sign"
                                d="M19.8897 16.1085L14.1961 22.1818C13.9215 22.4747 13.9215 22.9495 14.1961 23.2424L14.8602 23.9508C15.1343 24.2432 15.5786 24.2437 15.8534 23.952L20.3869 19.1388L24.9205 23.952C25.1953 24.2437 25.6395 24.2432 25.9137 23.9508L26.5777 23.2424C26.8523 22.9495 26.8523 22.4746 26.5777 22.1818L20.8841 16.1085C20.6095 15.8156 20.1643 15.8156 19.8897 16.1085Z" />
                        </g>
                    </g>
                    <defs>
                        <clipPath id="clip0">
                            <path d="M0 0H41.2524V41.8687H0V0Z" fill="white" />
                        </clipPath>
                        <clipPath id="clip1">
                            <rect width="10" height="15"
                                transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 27.6265 24.4343)" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <span>Back</span>
        </div>
    </section>

    <!-- Mobile steps cards container -->
    <section class="mobile-steps-cards-container">
        <article class="swiper-slide swiper-slide-active"
            *ngFor="let nextStep of resultsNextSteps; let i = index; let last = last">
            <header class="title-card">
                <img src="../../assets/img/{{nextStep.image}}" alt="" width="60px">
                <div class="title">{{nextStep.title}}</div>
            </header>
            <section class="main-card">
                <div class="header">
                    <img src="../../assets/img/{{nextStep.image}}" alt="" width="60px">
                </div>
                <div class="main">
                    <div class="title">{{nextStep.title}}</div>
                    <div class="explanations">{{nextStep.copy}}</div>
                    <ng-container *ngIf="nextStep.dropdown">
                        <select name="" id="">
                            <option *ngFor="let item of nextStep.dropdown">{{item}}</option>
                        </select>
                    </ng-container>
                    <div class="btn-part">
                        <input type="button" class="btn btn-primary primary-sml-btn" value="{{nextStep.buttonCopy}}"
                            [routerLink]="[nextStep.buttonLink]">
                        <span class="skip" (click)="skip(nextStep._id,i)">Skip X</span>
                    </div>
                </div>
            </section>
            <div class="pass" [ngClass]="{'last-child': last}"></div>
        </article>
    </section>
</ng-container>